<template>
  <div class="home">
    <div class="firstImg">
      <h1>深圳意达<br>&nbsp; &nbsp; &nbsp; &nbsp; 专注汽车零部件15年</h1>
      <h1 class="firstImg_logo">EDA</h1>
      <img src="@/img/chengshi3.jpg" alt="">
    </div>
    <!-- 企业介绍模块 -->
    <div class="qiye">
      <div class="qiye_boxs">
        <div class="qiye_left qiye_box">
          <div class="qiye_title">
            <span class="title1">走进</span><span class="title2">EDA</span><span class="yinghao">”EDA</span>
          </div>
          <div class="qiye_text">
            <span>{{ qiye_text }}</span>
          </div>
          <div class="qiye_bottom">
            <a href="/about">View More&nbsp;&nbsp;&nbsp;⇀</a>
          </div>
        </div>
        <div class="qiye_right qiye_box">
          <img src="@/img/yida.png" alt="">
        </div>
      </div>
      <img src="@/img/gaolou.png" alt="" class="qiye_background">
    </div>
    <!-- 手风琴模块 -->
    <div class="products">
      <div class="products_title">
        <span class="title1">经营</span>
        <span class="title2">理念</span>
        <span class="yinghao">”&nbsp;&nbsp;&nbsp;PHILOSOPHY</span>
      </div>
      <div class="linian">
        <div class="linian_left linian_box">
          <el-image 
            :src="linian">
            
          </el-image>
        </div>
        <div class="linian_right linian_box">
          <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1" class="linian_title">
            <template slot="title">
              <span>客户至上 <span class="linian_en">Customer First</span></span><i class="header-icon el-icon-s-custom"></i>
            </template>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 与了解需求：进行市场调研，了解客户偏好和需求。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 优质产品和服务：提供超出客户期望的高质量产品/服务。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 及时沟通：保持开放的沟通渠道，快速响应客户需求和反馈。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 建立信任：建立良好的客户关系，赢得客户的信任和忠诚度。</div>
          </el-collapse-item>
          <el-collapse-item name="2" style="font-size: 30px;">
            <template slot="title">
              <span>创新驱动 <span class="linian_en">Innovation-driven</span></span><i class="header-icon el-icon-s-opportunity"></i>
            </template>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 鼓励创新：激励员工提出新想法和解决方案。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 新产品开发：持续推出具有创新性的新产品，满足市场需求。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 技术领先：引领行业技术发展，保持竞争优势。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 市场敏锐：及时调整产品和服务以适应市场变化</div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <span>员工激励和发展 <span class="linian_en">Employee Incentives and Development</span></span><i class="header-icon el-icon-s-management"></i>
            </template>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 良好工作环境：提供舒适、安全的工作环境，关心员工的健康和福祉。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 持续培训：为员工提供培训和学习机会，持续提升员工技能。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 职业发展：制定职业发展计划，帮助员工实现个人职业目标。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 奖励激励：建立公平的奖励制度，激励员工积极工作并实现公司目标。</div>
          </el-collapse-item>
          <el-collapse-item title="可持续发展 Sustainable Development" name="4">
            <template slot="title">
              <span>可持续发展 <span class="linian_en">Sustainable Development</span></span><i class="header-icon el-icon-magic-stick"></i>
            </template>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 环境责任：实施环保实践，减少碳足迹。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 社会影响：参与社区发展项目，促进社会福利。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 经济可行性：平衡盈利与长期可持续发展目标。</div>
            <div>&nbsp; &nbsp; &nbsp; &nbsp; 资源效率：优化资源使用，减少废物产生。</div>
          </el-collapse-item>
        </el-collapse>
        </div>
      </div>
    </div>
    <!-- 特色产品 -->
    <div class="products">
      <div class="products_title">
        <span class="title1">特色</span>
        <span class="title2">产品</span>
        <span class="yinghao">”&nbsp;&nbsp;&nbsp;PRODUCTS</span>
        <a href="/product" class="products_bottom">VIEW MORE&nbsp;&nbsp;&nbsp;⇀</a>
      </div>
      <div class="products_imgs">
          <div class="products_img" v-for="img in products_imgs" :key="img.imgUrl">
            <a href="/product#products_boxs">
              <img :src="img.imgUrl">
              <div class="products_imgs_tag">
                <Icon class="icon" :type="img.type"></Icon>
                <h2 class="imgs_title">{{ img.title }}</h2>
                <p class="imgs_text">{{ img.text }}</p>
              </div>
              <div class="mengban"></div>
            </a>
          </div>
      </div>
    </div>
    <!-- <div class="products kehus">
      <div class="products_title">
        <span class="title1">终端</span>
        <span class="title2">客户</span>
        <span class="yinghao">”&nbsp;&nbsp;&nbsp;CLIENT</span>
        <a href="/product" class="products_bottom kehus_bottom">VIEW MORE&nbsp;&nbsp;&nbsp;⇀</a>
      </div>
      <div class="kehus_main">
        终端客户图片
        <div class="kehus_imgs" ref="kehus_imgs">
          <div class="kehus_img" v-for="(img,index) in kehus_imgs" :key="index">
            <img :src="img.imgUrl" alt="">
          </div>
        </div>
        箭头
        <h1 ref="jiantou_right" @click="kehuChange_right()" class="jiantou_right jiantou"><Icon type="jiantou"></Icon></h1>
        <h1 ref="jiantou_left" @click="kehuChange_left()" class="jiantou_left jiantou"><Icon type="jiantou"></Icon></h1>
      </div>
    </div> -->
    
    
  </div>
</template>

<script>
import Icon from '@/components/Icon';
export default {
  components:{
    Icon,
  },
  data() {
    return {
      activeName: '1',
      kehu_left:0,
      kehu_Change:264,
      qiye_text:"深圳市意达五金制品有限公司成立于2010年09月26日， 主要经营汽车零部件五金模具开发、冲压五金制品、新能源汽车零部件开发以及其他五金模具等。品质卓越，行业领先。公司一直秉承着“质量第一、客户至上”的经营理念，不断提升产品质量和服务水平，赢得了广大客户的信赖和支持。近年来，公司不断加强技术创新和产品开发，力求推出更加优质、高效的产品和服务，以满足市场的需求和客户的期望。",
      linian:require('@/img/kehu3.jpg'),
      products_imgs:[
        {
          type:"qiche",
          title:"汽车零部件",
          text:"精湛工艺，先进制造，质量可靠，技术领先",
          imgUrl:require('@/img/product1.jpg'),
        },
        {
          type:"xingnengyuan",
          title:"新能源",
          text:"精湛工艺，先进制造，质量可靠，技术领先",
          imgUrl:require('@/img/product2.jpg'),
        },
        {
          type:"qita",
          title:"其他产品",
          text:"精湛工艺，先进制造，质量可靠，技术领先",
          imgUrl:require('@/img/product3.jpg'),
        }
      ],
      kehus_imgs:[
        {name:"比亚迪",imgUrl:require('@/img/logo.jpg')},
        {name:"奥迪",imgUrl:require('@/img/logo15.png')},
        {name:"路虎",imgUrl:require('@/img/logo8.png')},
        {name:"法拉利",imgUrl:require('@/img/logo9.png')},
        {name:"玛莎拉蒂",imgUrl:require('@/img/logo.png')},
        {name:"保时捷",imgUrl:require('@/img/logo6.png')},
        {name:"丰田",imgUrl:require('@/img/logo2.png')},
        {name:"本田",imgUrl:require('@/img/logo3.png')},
        {name:"VOLVO",imgUrl:require('@/img/logo4.png')},
        {name:"福特",imgUrl:require('@/img/FT.png')},
        {name:"大众",imgUrl:require('@/img/logo5.png')},
        {name:"捷豹",imgUrl:require('@/img/logo7.png')},
        {name:"广汽",imgUrl:require('@/img/logo11.png')},
        {name:"日产",imgUrl:require('@/img/logo12.png')},
        {name:"长城",imgUrl:require('@/img/logo13.png')},
        {name:"红旗",imgUrl:require('@/img/logo16.png')},
        {name:"标致雪铁龙",imgUrl:require('@/img/logo17.jpg')},
        {name:"scania",imgUrl:require('@/img/scania.png')},
      ]
    }
  },
  methods:{
    goTo(url){
      this.$router.push(url);
    },
    kehuChange_right(){
      if(this.kehu_left<this.kehu_leftmax){
        this.kehu_left+=this.kehu_Change;
        this.$refs.kehus_imgs.style.transform = 'translateX(-'+this.kehu_left+'px)';
        this.jiantou_Change();
      }
    },
    kehuChange_left(){
      if(this.kehu_left>0){
        this.kehu_left-=this.kehu_Change;
        this.$refs.kehus_imgs.style.transform = 'translateX(-'+this.kehu_left+'px)';
        this.jiantou_Change();
      }
    },
    jiantou_Change(){
      if(this.kehu_left<this.kehu_leftmax){
        this.$refs.jiantou_right.style.color="#2155b0"
      }else{
        this.$refs.jiantou_right.style.color="#333"
      }
      if(this.kehu_left>0){
        this.$refs.jiantou_left.style.color="#2155b0"
      }else{
        this.$refs.jiantou_left.style.color="#333"
      }
    },
  },
  computed:{
    kehu_leftmax(){
      return (()=>{
        return (this.kehus_imgs.length-10)/2 * this.kehu_Change
      })()
    },
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* 第一张图片 */
.firstImg h1{
  position: absolute;
  left: 60%;
  top: 40%;
  transform: translate(-50%,-50%);
  color: #fff;
  letter-spacing: 10px;
  user-select: none;
  font-size: 35px;
  font-weight: 300;
}
.firstImg .firstImg_logo{
  left: 50%;
  font-weight: 1000;
  color: rgba(252, 252,252,0.15);
  font-size: 300px;
}
.firstImg img{
  object-fit:cover;
  /* 不重复 */
  background-repeat: no-repeat;
  height: 540px;
  width: 100%;
}
.home{
  width: 100%;
  background: #fff;
}
.firstImg{
  position: relative;
  font-size: 0px;
  width: 100%;
  min-width:1500px;
}
/* 企业宣传模块 */
.qiye_boxs{
  padding: 100px;
  padding-bottom: 200px;
  margin: 200px auto 0 auto;
  display: flex;
  width: 1500px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.qiye_background{
  width: 100%;
  min-width:1500px;
  left: 0vw;
  position: absolute;
  bottom: -130vh;
  // filter: grayscale(100%) brightness(0);
  opacity:0.3;
  z-index: 1;
}
.qiye{
  width: 100%;
  overflow: hidden;
  position: relative;
  min-width:1500px;
}
.qiye_box{
 flex: 1;
}
.qiye_left{
  padding-right: 50px;
}
.qiye_title{
  border-bottom: 2px solid #eee;
  font-size: 40px;
  letter-spacing:2px;
  font-weight: 600;
  color: #333;
  padding-bottom: 25px;
}
.title1{
  padding-bottom: 25px;
  border-bottom: 2px solid #2155b0;
}
.title2{
  padding-bottom: 25px;
  color: #2155b0;
}
.qiye_text{
  margin: 40px 0;
  line-height: 2em;
  color: #777;
}
.qiye_right{
  text-align: right;
  width: 200px;
  position: relative;
}
.qiye_right img{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow:0 0 4px rgba(0,0,0,0.5);
}
.qiye_bottom{
  margin-top: 50px;
}
.qiye_bottom a{
  background: #2155b0;
  padding: 10px 25px;
  color: #fff;
  font-weight: 345;
  font-size: 14px;
}
.yinghao{
  margin-left: 20px;
  color: #eee;
  letter-spacing:2.5px;
}
// 手风琴模块
.linian{
  margin-top: 50px;
  padding: 0 50px;
  display: flex;
}
.el-collapse-item__header{
  margin: 100px 0;
}
.linian_box{
  flex: 1;
}
.linian_left{
  margin-bottom:50px;
  margin-left: 50px;
}
.linian_right{
  margin-left: 30px;
}
.linian .linian_en{
  color: rgba(0,0,0,0.3);
  font-size: 14px;
}
.linian div{
  font-size: 14px;
  color: #777;
  line-height: 2em;
}
.linian span{
  font-size: 20px;
  color: #777;
}
.header-icon{
  font-size: 30px;
  margin-left: 20px;
}
/* 特色产品 */
.products{
  border-top: 2px solid rgba(33, 85, 176,0.5);
  width: 1500px;
  margin: 120px auto;
}
.products_title{
  font-size: 40px;
  padding: 50px 100px 20px 100px;
  position: relative;
  font-weight: 600;
}
.products_imgs{
  display: grid;
  grid-template-columns:auto auto auto;
  column-gap: 50px; 
  padding: 50px 100px;
}
.products_bottom{
  color: #2155b0;
  font-weight: 350;
  font-size: 14px;
  border: 2px solid #2155b0;
  padding: 10px 20px;
  text-align:right;
  right: 100px;
  bottom: 0;
  position: absolute;
  &:hover{
    background: #fff;
    border: 2px solid #4877c4;
    color: #4877c4;
  }
}
.products_img{
  width: 100%;
  height: 500px;
  position: relative;
  cursor: pointer;
  &:hover .mengban{
    background: linear-gradient(to bottom, rgba(12,23,41,0.1), rgba(12,23,41,0.4));
    cursor:pointer;
  }
}
.products_img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0 0 2px rgba(0,0,0,0.5)
}
.products_imgs_tag{
  position: absolute;
  bottom: 30px;
  left: 30px;
  color: #fff;
  line-height: 2em;
  z-index: 2;
}
.products .iconfont{
  font-size: 35px;
}
.products_imgs_tag .icon{
  line-height: 70px;
}
.products_imgs_tag .imgs_title{
  font-weight: 400;
  font-size: 20px;
}
.products_imgs_tag .imgs_text{
  font-weight: 380;
  font-size: 14px;
}
.mengban{
  top:0;
  z-index: 1;
  background: linear-gradient(to bottom, rgba(12,23,41,0.1), rgba(12,23,41,0.7));
  position: absolute;
  width: 100%;
  height: 100%;
}
// 终端客户模块
.kehus{
  position: relative;
}
.kehus_main{
  width: 1300px;
  padding: 50px 0px;
  overflow: hidden;
  margin: 0 auto;
}
.kehus_imgs{
  display: grid;
  grid-template-rows:125px 125px;
  gap: 20px 20px; /* 行间隙为10px，列间隙为20px */
  grid-auto-flow: column; 
  transition: 1s;
  //每264px为一个转，三下为上限
  // transform: translateX(-264px);
}
.kehus_img{
  width: 244px;
  border: 1px solid #eee;
  box-shadow:0 0 1px #777;
  cursor: pointer;
  &:hover{
    border: 1px solid #2155b0;
  }
}
.kehus_img img{
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform:scale(0.85);

}
.kehus_bottom{
  border: 0px solid #2155b0;
  background: #2155b0;
  color: #fff;
  font-weight: 300;
  &:hover{
    background: #2155b0;;
    border: 0px solid #2155b0;
    color: #fff;
  }
}
.jiantou{
  position: absolute;
  top: 59%;
  cursor: pointer;
}
.jiantou_right{
  right: 3.5%;
  color: #2155b0;
}
.jiantou_left{
  left: 3.5%;
  transform: rotate(0.5turn); 
}
</style>